export const PDF_ZOOM_MIN = 0.5;
export const PDF_ZOOM_MAX = 4;
export const PDF_ZOOM_STEP = 0.1;

export function clampPdfZoom(value: number): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 1;
  return Math.min(PDF_ZOOM_MAX, Math.max(PDF_ZOOM_MIN, Number(n.toFixed(2))));
}

export function nudgePdfZoom(value: number, delta: number): number {
  return clampPdfZoom(value + delta);
}

export function pinchDistance(a: { clientX: number; clientY: number }, b: { clientX: number; clientY: number }): number {
  const dx = a.clientX - b.clientX;
  const dy = a.clientY - b.clientY;
  return Math.hypot(dx, dy);
}
